import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Theme, useMediaQuery } from "@mui/material";
import SourceFiles from "../SourceFiles";
import SourceDatabase from "../SourceDatabase";
import SourceFaq from "../SourceFaq";
import SourceText from "../SourceText";
import SourceSharepoint from "../SourceSharepoint";
import { Params, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import {
  ShowError,
  ShowSuccess,
} from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { FILE_UPLOAD_AGENT, FILE_UPLOAD_TEMPLATE, GET_AGENT } from "../../../Services/Endpoint";
import TabPanel, {
  a11yProps,
} from "../../../Shared-ui/SharedComponents/TabPanel";
import Template from "../../../Shared-ui/Types/Template";
import SourceWebsite from "../SourceWebsite";
import SourceGithub from "../SourceGithub";
import SourceYoutube from "../SourceYoutube";
import SourceSlack from "../SourceSlack";


const Source = () => {
  const [value, setValue] = React.useState(0);
  const [knowledgeBase, setknowledgeBase] = useState<OldAgent | Template>();
  const [tabValue, setTabValue] = useState(0);
  const { agentId } = useParams<Params>();
  const { templateId } = useParams<Params>();

  const dispatch = useDispatch();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    getknowledgeBase();
  }, [agentId]);

  const getknowledgeBase = async () => {
    try {
      dispatch(StartLoading());
      const pathname = window.location.pathname;
      const basePath = pathname.split('/').slice(0, -1).join('/');
      let url = ""
      let id = ""
      if (basePath === "/template" && templateId) {
        url = FILE_UPLOAD_TEMPLATE
        id = templateId
      }
      if (basePath === "/agent" && agentId) {
        url = FILE_UPLOAD_AGENT
        id = agentId

      }
      const data = await MetaInstance.get(`${url}/${id}`).then(
        (res) => res?.data?.detail
      );
      setknowledgeBase(data.response);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading());
    }
  };

  const updateknowledgeBase = async () => {
    try {
      dispatch(StartLoading());
      const pathname = window.location.pathname;
      const basePath = pathname.split('/').slice(0, -1).join('/');
      let url = ""
      let id = ""
      if (basePath === "/template" && templateId) {
        url = FILE_UPLOAD_TEMPLATE
        id = templateId
      }
      if (basePath === "/agent" && agentId) {
        url = FILE_UPLOAD_AGENT
        id = agentId

      }
      const data = await MetaInstance.put(
        `${url}/${id}`,
        knowledgeBase
      ).then((res) => res?.data?.detail);
      getknowledgeBase();
      dispatch(ShowSuccess(data?.response));
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading());
    }
  };
  // Vertical Tabs
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Media query to check screen size
  const isSmallDevice = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "none",
        display: "flex",
        gap: 4,
        flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
      }}
    >
      <Tabs
        orientation={isSmallDevice ? "horizontal" : "vertical"} // Adjust orientation dynamically
        variant="scrollable"
        value={tabValue}
        onChange={handleTabChange}
        aria-label="Dynamic Tabs"
        textColor="primary"
        indicatorColor="primary"
        sx={{
          borderRight: isSmallDevice ? 0 : 1, // Remove border on small devices
          borderBottom: isSmallDevice ? 1 : 0, // Add bottom border on small devices
          borderColor: "divider",
          minWidth: isSmallDevice ? "100%" : "200px", // Adjust width
        }}
      >
        <Tab
          label="Files"
          {...a11yProps(0)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />

        <Tab
          label="Database"
          {...a11yProps(1)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
        {/* <Tab
          label="Sharepoint"
          {...a11yProps(2)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        /> */}
        <Tab
          label="Website"
          {...a11yProps(2)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
        <Tab
          label="FAQ"
          {...a11yProps(3)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
        <Tab
          label="GitHub"
          {...a11yProps(4)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
        <Tab
          label="YouTube"
          {...a11yProps(5)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
        <Tab
          label="Slack"
          {...a11yProps(6)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
        <Tab
          label="Sharepoint"
          {...a11yProps(7)}
          sx={{
            textTransform: "capitalize",
            alignItems: isSmallDevice ? "center" : "flex-start",
            p: 0,
          }}
        />
      </Tabs>



      <TabPanel width="calc(100% - 200px)" value={tabValue} index={0}>
        <SourceFiles
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase}
        />
      </TabPanel>
      {/*<TabPanel width="calc(100% - 200px)" value={tabValue} index={1}>*/}
      {/*  <SourceText />*/}
      {/*</TabPanel>*/}

      <TabPanel width="calc(100% - 200px)" value={tabValue} index={1}>
        <SourceDatabase
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase}
        />
      </TabPanel>
      {/* <TabPanel width="calc(100% - 200px)" value={tabValue} index={2}>
        <SourceSharepoint />
      </TabPanel> */}
      <TabPanel width="calc(100% - 200px)" value={tabValue} index={2}>
        <SourceWebsite
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase} />
      </TabPanel>
      <TabPanel width="calc(100% - 200px)" value={tabValue} index={3}>
        <SourceFaq
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase} />
      </TabPanel>
      <TabPanel value={tabValue} index={4}>
        <SourceGithub
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase} />
      </TabPanel>
      <TabPanel value={tabValue} index={5}>
        <SourceYoutube
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase} />
      </TabPanel>
      <TabPanel value={tabValue} index={6}>
        <SourceSlack
          knowledgeBase={knowledgeBase}
          getknowledgeBase={getknowledgeBase}
          setknowledgeBase={setknowledgeBase}
          updateknowledgeBase={updateknowledgeBase} />
      </TabPanel>
      <TabPanel width="calc(100% - 200px)" value={tabValue} index={7}>
        <SourceSharepoint />
      </TabPanel>
    </Box>
  );
};

export default Source;
